<template>
  <b-form-group
    label="Açıklama"
    label-for="notes"
  >
    <b-form-textarea
      id="notes"
      v-model="dataItem.notes"
      placeholder="Açıklama"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'Notes',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
  },
}
</script>
